import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../../common/theme/ISpcTheme';

export type MyAccountContainerClasses = 'myAccountWrapper' | 'saveOfferButton';

const myAccountContainerStyles = makeStyles<ISpcTheme, MyAccountContainerClasses>(
  theme => ({
    myAccountWrapper: {
      boxSizing: 'border-box',
      width: '100%',
      minHeight: '20rem',
      marginTop: '12rem',
      [theme.breakpoints.up('sm')]: {
        marginTop: '0',
      },
      [theme.breakpoints.up('md')]: {
        maxWidth: '720px',
      },
      [theme.breakpoints.down('xs')]: {
        paddingLeft: '0',
        paddingRight: '0',
      },
    },
    saveOfferButton: {
      width: '11.5rem',
      paddingTop: '1rem',
      paddingBottom: '1rem',
      '& span': {
        fontSize: theme.typography.pxToRem(theme.typography.fontMD),
      },
    },
  }),
  { name: 'PCatalog_MiniSpcContainer' },
);

export default myAccountContainerStyles;
